import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StaffTable from "../components/StaffTable";
import { API_URL } from "..";

const StaffPage = () => {
    const [data,setData] = useState([]);
    const fetchUser  = async () =>{
        let headerList = {
            Accept: "*/*",
            "Content-type": "application/json",
          };
          const response = await fetch(
            API_URL+`/api/user/fetch`,
            { method: "GET", headers: headerList }
          );
          const dataFor = await response.json();
          if (response.status === 200) {
              setData(dataFor.data)
              console.log(dataFor.data)
            
          }
    }   
    React.useEffect(()=>{
        fetchUser()
    },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Staff" />

        {/* TableDataLayer */}
        {
            data.length === 0? null :
        <StaffTable  data={data}/>
        }

      </MasterLayout>

    </>
  );
};

export default StaffPage; 
